import React from 'react'

interface Props {
  children: React.ReactNode
}

// 4-up on desktop (md+), 2-up below. Fixed columns so "Budget vs Target"
// doesn't orphan to its own row at editor width.
export const KPIGrid = ({ children }: Props) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">{children}</div>
)
